function t(t,a,e,i){t._m(a),t.o(a,"AuthenticationLayoutTemplate",()=>t.f(n));var n=t.i(e("81860e41"));}